module.exports = __webpack_public_path__ + "static/media/HCMM140.26c53fde.jpg";